import {
  IdDocumentWarnings,
  IdDocumentWarningsInput
} from '../../lib/types/models/affectedStaff/id-document-warnings'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getIdDocumentWarnings(input: IdDocumentWarningsInput) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.getIdDocumentWarnings.url, null))
    .query(input)
    .get<IdDocumentWarnings>()
}
